module.exports = __webpack_public_path__ + "static/media/1-watercolour.2a08426d.png";